import { StepBase } from './StepBase';
import { PageStepType } from './PageTypes';
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { TaskManager } from '../Tasks/TaskManager';
import { DataFormatter } from '../dataformats/DataFormatter';
import { FieldStatusType } from '../utils/DataDictionary';

// Library for Events that are strongly typed
// see https://github.com/vitaly-t/sub-events
import { SubEvent } from 'sub-events';

/**
 *
 * Option "FieldEnabled"
 *      Text - The condition to evaluate as true or false
 *      field_id - A form field that is enabled if true or disabled.
 *
 */

export class StepConditional extends StepBase {
    /** Raw string value of the command */
    conditionalText: string = '';

    /* Field that is affected */
    field: string = '';

    /* Compare value to know if something has changed */
    lastValue: any = undefined;

    /** Field status represent if it is warning or error */
    conditionalType: FieldStatusType = 'warning';

    /**
     * Called after the condition is evaluated
     */
    checkCondition(value: any): StepConditional.ConditionalEvent | undefined {
        if (this.lastValue === value) return undefined;

        this.lastValue = value;

        if (this.options.checkOption('FieldEnabled')) {
            //  Field that is affected
            const field: string = this.raw.field_id ? this.raw.field_id : '';

            //  Convert the result into a boolean
            let df = new DataFormatter();
            let boolValue = df.unformatData('Boolean', value);
            if (value === undefined) boolValue = false;
            if (value === '') boolValue = false;

            console.log('StepConditional value=', value, boolValue, ' for ', field);
            const result: StepConditional.FieldEnabledEvent = {
                field,
                eventType: 'FieldEnabled',
                enabled: boolValue,
                field_status: 'warning',
            };

            return result;
        } else {
            console.log('StepConditional processStep, unknown action type for task:', this.raw);
        }
    }

    async processStep(logic: LogicEngine): Promise<boolean> {
        this.conditionalText = this.text;

        if (!this.raw.field_id) this.field = '';
        else this.field = this.raw.field_id;

        return true;
    }
}

export namespace StepConditional {
    export interface ConditionalEvent {
        field: string;
        eventType: string;
    }

    export interface FieldEnabledEvent extends ConditionalEvent {
        enabled: boolean;
        field_status: FieldStatusType;
    }
}
